import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import GroupFiles from '../FileShare/GroupFiles';
// import Group from '../../components/Group';
import Modal from '../../components/Modal/modal';
import Snackbar from '@material-ui/core/Snackbar';
// import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import { bindActionCreators } from 'redux';
import {
  switchAddMemberForm,
  setInitAlert,
  setReduxGroupAlert,
  deleteGroups,
} from '../../redux/actions/group';

// import MemberInviteModal from '../../components/Modal/MemberInviteModal';
// import ConfirmDialog from '../../components/ConfirmDialog';

const useStyles = makeStyles((theme) => ({
  actionsWrapper: {
    width: '100%',
    display: 'flex',
  },
  closeWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  actionsLeft: {
    width: '33%',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  actionsRight: {
    width: '66%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  deleteGroupBtn: {
    width: '140px',
    backgroundColor: '#dc004e',
    margin: theme.spacing(1),
    '&:hover': {
      background: '#9a0036',
    },
  },
  cancelBtn: {
    width: '120px',
    margin: theme.spacing(1),
  },
  inviteMemberBtn: {
    width: '140px',
    margin: theme.spacing(1),
    '&:hover .MuiCircularProgress-circle': {
      color: '#4caf50',
    },
    '& .MuiCircularProgress-circle': {
      color: '#1b5e20',
    },
  },
  groupAlert: {
    '& .MuiAlert-filledSuccess': {
      backgroundColor: '#1b5e20',
    },
  },
}));

const GroupDriveModal = (props) => {
  const { dispatch, show, close, groupData, groupAlert, member } = props;

  const classes = useStyles();
  const title = groupData.group_name;

  const hideAlert = () => {
    props.setReduxGroupAlert({
      show: false,
      variant: groupAlert.variant,
      message: '',
    });
  };

  const modalHide = () => {
    dispatch(setInitAlert());
    dispatch(switchAddMemberForm());
    close();
  };

  const isLeader = groupData.group_leader_id === member.member_id;
  const ModalContent = () => (
    <Grid container spacing={2} direction="row">
      <Grid item sm={12}>
        <GroupFiles
          key={groupData.group_id}
          groupId={groupData.group_id}
          isLeader={isLeader}
        />
      </Grid>
    </Grid>
  );

  const ModalAction = () => {
    return (
      <div className={classes.closeWrapper}>
        <Button
          variant="contained"
          color="secondary"
          disableRipple
          className={classes.cancelBtn}
          onClick={() => close()}
        >
          Close
        </Button>
      </div>
    );
  };

  return (
    <>
      {groupAlert.show && (
        <Snackbar
          open={groupAlert.show}
          autoHideDuration={5000}
          onClose={hideAlert}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <div className={classes.groupAlert}>
            <Alert
              onClose={hideAlert}
              variant="filled"
              severity={groupAlert.variant}
            >
              {groupAlert.message}
            </Alert>
          </div>
        </Snackbar>
      )}
      <Modal
        open={show}
        onClose={modalHide}
        title={title}
        ModalContent={ModalContent}
        ModalAction={ModalAction}
        className="group-detail-modal"
      />
    </>
  );
};

GroupDriveModal.propTypes = {
  dispatch: PropTypes.func,
  groupData: PropTypes.object,
  show: PropTypes.bool,
  close: PropTypes.func,
};

GroupDriveModal.defaultProps = {
  dispatch: null,
  groupData: {},
  show: false,
  close: null,
};

const mapStateToProps = (state) => ({
  groupAlert: state.group.groupAlert,
  groupData: state.group.groupData,
  member: state.member.member,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators({ deleteGroups, setReduxGroupAlert }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupDriveModal);
